import React from "react";
import { dollarFormatter } from "utils";
import { OverallTotals } from "../types";

interface StatementSummaryCardsProps {
  overallTotals: OverallTotals;
  tr: (key: string) => string;
}

export default function StatementSummaryCards({
  overallTotals,
  tr,
}: StatementSummaryCardsProps) {
  return (
    <div className="statement-summary-grid grid grid-cols-1 sm:grid-cols-3 gap-4">
      <div className="bg-slate-50 border border-slate-200 rounded-xl p-4 text-center">
        <p className="text-xs font-semibold text-slate-500 uppercase tracking-wider m-0">
          {tr("Total Invoiced")}
        </p>
        <p className="text-xl font-bold text-slate-900 mt-1 m-0">
          {dollarFormatter(overallTotals.totalInvoiced) || "$0.00"}
        </p>
      </div>
      <div className="bg-emerald-50/60 border border-emerald-200 rounded-xl p-4 text-center">
        <p className="text-xs font-semibold text-emerald-700 uppercase tracking-wider m-0">
          {tr("Total Paid")}
        </p>
        <p className="text-xl font-bold text-emerald-800 mt-1 m-0">
          {dollarFormatter(overallTotals.totalPaid) || "$0.00"}
        </p>
      </div>
      <div className="bg-amber-50/80 border border-amber-200 rounded-xl p-4 text-center">
        <p className="text-xs font-semibold text-amber-800 uppercase tracking-wider m-0">
          {tr("Total Outstanding Due")}
        </p>
        <p className="text-xl font-bold text-amber-900 mt-1 m-0">
          {dollarFormatter(overallTotals.totalDue) || "$0.00"}
        </p>
      </div>
    </div>
  );
}
